import React from 'react'
import { WebhookRequestDetailProps } from './type'
import IMRequestDetail from './IMRequestDetail'

const QiyeWXRequestDetail = ({ requestPayload }: WebhookRequestDetailProps) => {
  return <IMRequestDetail requestPayload={requestPayload} targetsKey="mentionedMobileList" />
}

export default QiyeWXRequestDetail
